<template>
  <div>
    <el-dialog
      :title="'案件详情'"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5vh">

      <div class="case-detail-container" v-loading="loading">
        <!-- 案件基本信息卡片 -->
        <el-card class="case-info-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="card-title">案件基本信息</span>
          </div>

          <el-row :gutter="20">
            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">项目：</label>
                <span class="info-value">{{ caseInfo.project.name }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">房产：</label>
                <span class="info-value">{{ caseInfo.house && caseInfo.house.ancestor_name ? caseInfo.house.ancestor_name : '' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">法院：</label>
                <span class="info-value">{{ caseInfo.court.name }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">原告：</label>
                <span class="info-value">{{ caseInfo.plaintiff }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">被告：</label>
                <span class="info-value">{{ caseInfo.defendant }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">案件金额：</label>
                <span class="info-value">{{ caseInfo.legal_money | currencyFormat }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">执行金额：</label>
                <span class="info-value">{{ caseInfo.pay_money | currencyFormat }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">案件状态：</label>
                <el-tag :type="getStatusType(caseInfo.case_status)" class="status-tag">{{ getStatusText(caseInfo.case_status) }}</el-tag>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">资料状态：</label>
                <el-tag :type="caseInfo.is_complete ? 'success' : 'warning'" class="status-tag">
                  {{ caseInfo.is_complete ? '已完善' : '待完善' }}
                </el-tag>
              </div>
            </el-col>
          </el-row>
        </el-card>

        <!-- 房产资料卡片 -->
        <el-card class="house-info-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="card-title">房产资料</span>
          </div>

          <el-row :gutter="20">
            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">客户类型：</label>
                <span class="info-value">{{ caseInfo.house_status.customer_type === 1 ? '个人' : '企业' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">业主姓名：</label>
                <span class="info-value">{{ caseInfo.house_status.customer_name }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">业主电话：</label>
                <span class="info-value">{{ caseInfo.house_status.phone }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">身份证/组织机构代码：</label>
                <span class="info-value">{{ caseInfo.house_status.credentials_code }}</span>
              </div>
            </el-col>

            <!-- <el-col :span="12">
              <div class="info-item">
                <label class="info-label">物业服务合同：</label>
                <span class="info-value">
                  <el-row>
                    <el-col :span="12">
                      <span v-if="caseInfo.house_status.service_contract == ''">未上传</span>
                      <el-link v-else type="primary" @click="viewFile(caseInfo.house_status,'service_contract')">查看</el-link>
                    </el-col>
                  </el-row>
                </span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">房屋买卖合同/房屋产权证：</label>
                <span class="info-value">
                  <el-row>
                    <el-col :span="12">
                      <span v-if="caseInfo.house_status.room_contract == ''">未上传</span>
                      <el-link v-else type="primary" @click="viewFile(caseInfo.house_status,'room_contract')">查看</el-link>
                    </el-col>
                  </el-row>
                </span>
              </div>
            </el-col> -->

            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">材料是否已完整：</label>
                <span class="info-value">
                  <el-row>
                    <el-col :span="12">
                      <span v-if="caseInfo.is_complete == '0'">未完整</span>
                      <span v-else>已完整</span>
                      </el-col>
                  </el-row>
                </span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="info-item">
                <label class="info-label">催缴记录：</label>
                <span class="info-value">
                  <el-row>
                    <el-col :span="12">
                      <el-link type="primary" @click="showRecord">查看催缴记录</el-link>
                    </el-col>
                  </el-row>
                </span>
              </div>
            </el-col>
          </el-row>
        </el-card>

        <!-- 办案列表 -->
        <el-card class="handling-list-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="card-title">办案列表</span>
          </div>

          <el-table
            :data="handlingList"
            stripe
            style="width: 100%"
            :header-cell-style="{background: '#f5f7fa', color: '#606266'}">
            <el-table-column label="执行类型" width="150">
              <template slot-scope="scope">
                {{ getFlowTypeName(scope.row.flow_type) }}
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="180">
            </el-table-column>
            <el-table-column label="执行内容" min-width="200">
              <template slot-scope="scope">
                {{ scope.row.flow_data | flowData }}
              </template>
            </el-table-column>
            <el-table-column label="上传资料" min-width="200">
              <template slot-scope="scope">
                <el-link v-for="(file,index) in scope.row.file_list" :key="index"  @click="fileDownload(file.file_url)">{{ file.file_name }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="flowStatus" label="流程状态" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.task_status == 0">未发起</span>
                <span v-if="scope.row.task_status == 1">进行中</span>
                <span v-if="scope.row.task_status == 2">已完成</span>
                <span v-if="scope.row.task_status == -1">不通过</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope" v-if="!['court', 'accept'].includes(scope.row.flow_type)">
                <el-link v-if="scope.row.task_status == 0 && ['file' , 'fill' ,'preservation' , 'court' , 'discount' , 'appeal' , 'execute'].includes(scope.row.flow_type)" @click="openTask(scope.row)">发起流程</el-link>

                <el-link v-if="scope.row.task_status == 0" @click="deleteFlow(scope.row)">删除</el-link>
                <el-link v-else @click="gotoTask(scope.row)">查看流程</el-link>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-wrapper" v-if="total > 0">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </el-card>

        <!-- 关联订单折叠卡片 -->
        <el-collapse v-model="orderCollapse" accordion v-if="caseInfo.order_list && caseInfo.order_list.length > 0">
          <el-collapse-item name="order">
            <template slot="title">
              <span class="card-title">关联订单</span>
            </template>
            <div style="margin-bottom: 15px; font-size: 16px; font-weight: bold; color: #303133;">
              欠费总额 ：￥ {{ totalArrearsAmount }}
            </div>

            <el-table
              :data="orderListData"
              style="width: 100%"
              border
              :header-cell-style="{background: '#f5f7fa', color: '#606266'}"
            >
              <el-table-column
                prop="charge_item"
                label="收费项目"
              >
              </el-table-column>
              <el-table-column
                prop="billing_start_time"
                label="计费开始时间"
              >
              </el-table-column>
              <el-table-column
                prop="billing_end_time"
                label="计费结束时间"
              >
              </el-table-column>
              <el-table-column
                prop="receivable_amount"
                label="应收金额"
              >
                <template slot-scope="scope">
                  ¥{{ scope.row.receivable_amount }}
                </template>
              </el-table-column>
              <el-table-column
                prop="received_amount"
                label="已收金额"
              >
                <template slot-scope="scope">
                  ¥{{ scope.row.received_amount }}
                </template>
              </el-table-column>
              <el-table-column
                prop="arrears_amount"
                label="欠费金额"
              >
                <template slot-scope="scope">
                  ¥{{ scope.row.arrears_amount }}
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
      </div>
    </el-dialog>

    <ViewFileList ref="viewFileListRef" />
    <LegalHouseInfo ref="LegalHouseInfo" />
  </div>
</template>

<script>
import moment from "moment/moment";
import ButlerHttp from "../../common/ButlerHttp";
import caseJs from './case.js';
import ViewFileList from "../../../Common/ViewFileList";
import LegalHouseInfo from "../LegalHouseInfo.vue";

export default {
  name: 'CaseDetailDialog',
  components : {LegalHouseInfo, ViewFileList },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caseId: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    totalArrearsAmount() {
      if (!this.orderListData || this.orderListData.length === 0) {
        return 0;
      }
      return this.orderListData.reduce((sum, order) => {
        const amount = parseFloat(order.arrears_amount) || 0;
        return sum + amount;
      }, 0).toFixed(2);
    }
  },
  data() {
    return {
      loading: false,
      caseInfo: {
        project: {},
        house: {},
        court: {},
        plaintiff: '',
        defendant: '',
        legal_money: 0,
        pay_money: 0,
        case_status: 0,
        is_complete: false,
        house_status : {},
        order_list : [],
      },
      handlingList: [],
      orderListData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orderCollapse: [],
    }
  },
  watch: {
    caseId: {
      handler(newVal) {
        if (newVal && this.visible) {
        }
      },
      immediate: true
    },
    visible: {
      handler(newVal) {
        if (newVal && this.caseId) {
          this.getCaseDetail();
        }
      },
      immediate: true
    }
  },
  methods: {
    getStatusType(status) {
      const typeMap = {
        0: 'info',
        1: 'primary',
        2: 'warning',
        3: 'success',
        4: 'success',
        5: 'default'
      };
      return typeMap[status] || 'default';
    },

    getStatusText(status) {
      const textMap = {
        0: '未提交',
        1: '已提交',
        2: '调解中',
        3: '已立案',
        4: '已结案',
        5: '第三方管理'
      };
      return textMap[status] || '未知';
    },

    getFlowTypeName(type) {
      const flowTypeMap = {
        'submit_court': '提交法院',
        'accept': '受理成功',
        'reject': '拒绝受理',
        'preservation': '诉讼保全',
        'court': '开庭记录',
        'appeal': '上诉申请',
        'fill': '诉讼费用',
        'mediation': '调解过程',
        'discount': '折扣申请',
        'execute': '案件执行',
        'close': '回款结案',
        'third' : '案件转移',
        'pay' : '案件执行',
        'file' : '资料盖章',
      };
      return flowTypeMap[type] || type;
    },

    async getCaseDetail() {
      this.loading = true;
      try {
        ButlerHttp.get('LawCase/caseInfo' , {id : this.caseId} , res => {
          if(res.code){
            this.caseInfo = res.data;
            this.handlingList = res.data.flow_list || [];
            this.processOrderList();
          }else{
            this.$message.error(res.msg);
          }
          this.loading = false;
        })
      } catch (error) {
        console.error('获取案件详情失败:', error);
        this.$message.error('获取案件详情失败');
        this.loading = false;
      }
    },

    fileDownload(url){
      let open_url = caseJs.getFileUrl(url)
      window.open(open_url)
    },

    deleteFlow(row){
      if(row.task_status == 0){
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ButlerHttp.get('LawCase/deleteFlow' , {id : row.id} , res => {
            if(res.code){
              this.$message.success('删除成功');
              this.getCaseDetail();
            }else{
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }else{
        this.$message.error('请勿删除进行中的流程');
      }
    },

    gotoTask(row){
      let url =  `https://crm.gdzawy.com:9000/#/flow/FlowView?task_id=${row.task_id}&is_look=1`
      window.open(url)
    },

    openTask(row){
      let url = '';
      let project_type = this.caseInfo.project_type || 1;
      let amount = this.caseInfo.legal_money || 0;

      if (row.flow_type === 'accept') {
        const urlParams = {
          sheet_id: project_type === 1 ? '349' : '350',
          master_id: project_type === 1 ? '286' : '287',
          timeValue: caseJs.getTimestamp(),
          batch_no: row.batch_no,
          amount: amount,
          type: '受理成功'
        };
        url = `https://crm.gdzawy.com:9000/#/flow/FlowView?${new URLSearchParams(urlParams).toString()}`;
      } else if (['court', 'preservation', 'appeal'].includes(row.flow_type)) {
        const typeMap = {
          'appeal': '二审',
          'court': '开庭记录',
          'preservation': '诉讼保全'
        };
        const urlParams = {
          sheet_id: '349',
          master_id: '286',
          timeValue: caseJs.getTimestamp(),
          batch_no: row.batch_no,
          amount: amount,
          type: typeMap[row.flow_type] || row.flow_type
        };
        url = `https://crm.gdzawy.com:9000/#/flow/FlowView?${new URLSearchParams(urlParams).toString()}`;
      } else if (row.flow_type === 'fill') {
        url = "https://crm.gdzawy.com:9000/#/flow/FlowView?sheet_id=351&master_id=288&timeValue=" + caseJs.getTimestamp() + "&batch_no=" + row.batch_no;
      } else if (row.flow_type === 'discount') {
        let discountRate = '';
        if (row.flow_data && row.flow_data.discount_rate) {
          discountRate = row.flow_data.discount_rate + '%折';
        }
        const urlParams = {
          sheet_id: '352',
          master_id: '289',
          timeValue: caseJs.getTimestamp(),
          batch_no: row.batch_no,
          amount: amount,
          type: discountRate
        };
        url = `https://crm.gdzawy.com:9000/#/flow/FlowView?${new URLSearchParams(urlParams).toString()}`;
      } else {
        url = "https://crm.gdzawy.com:9000/#/flow/FlowView?sheet_id=312&master_id=252&timeValue=" + caseJs.getTimestamp() + "&batch_no=" + row.batch_no;
      }
      window.open(url);
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
    },

    handleCurrentChange(val) {
      this.currentPage = val;
    },

    viewFile(item , name) {
      const that=this;
      that.$refs.viewFileListRef.show(item[name])
      that.$refs.viewFileListRef.onList(list=>{
        if(list.length===0){
          that.getCaseDetail();
        }
      })
    },

    showRecord(){
      let project_id = 0;
      let house_id = 0;
      if(this.caseInfo.house.host_precinct_id > 0){
        project_id = this.caseInfo.house.host_precinct_id;
      }else{
        project_id = this.caseInfo.house.project_house_id;
      }

      if(this.caseInfo.house.host_house_id > 0){
        house_id = this.caseInfo.house.host_house_id;
      }else{
        house_id = this.caseInfo.house.house_id;
      }

      this.$refs.LegalHouseInfo.show({
        project_house_id : project_id ,
        house_id : house_id ,
      })
    },

    processOrderList() {
      if(this.caseInfo.order_list && this.caseInfo.order_list.length > 0){
        this.orderListData = this.caseInfo.order_list.map(order => ({
          house_name: order.house_name || '',
          charge_item: order.charge_name || '',
          billing_start_time: this.formatDate(order.startDate),
          billing_end_time: this.formatDate(order.endDate),
          receivable_amount: order.charge,
          received_amount: order.PaidChargeSum,
          arrears_amount: (parseFloat(order.charge) - parseFloat(order.PaidChargeSum) + parseFloat(order.adjust)).toFixed(2),
        }));
      } else {
        this.orderListData = [];
      }
    },

    formatDate(timestamp) {
      if (!timestamp) return '';
      return moment(timestamp * 1000).format('YYYY-MM-DD');
    },

    handleClose() {
      this.$emit('close' , false);
      this.$emit('update:visible', false);
    },
  },
  filters: {
    currencyFormat(value) {
      if (!value && value !== 0) return '¥0.00';
      return '¥' + Number(value).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    flowData(data){
      return caseJs.flowData(data);
    },
  }
}
</script>

<style scoped>
.case-detail-container {
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 10px;
}

.case-info-card {
  margin-bottom: 20px;
}

.order-info-card {
  margin-bottom: 20px;
}

.house-info-card {
  margin-bottom: 20px;
}

.card-title {
  font-weight: bold;
  font-size: 16px;
}

.info-item {
  display: flex;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px dashed #ebeef5;
}

.info-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.info-label {
  width: 200px;
  color: #909399;
  font-weight: normal;
}

.info-value {
  flex: 1;
  color: #303133;
}

.status-tag {
  height: 24px;
  line-height: 22px;
  padding: 0 10px;
}

.handling-list-card {
  margin-bottom: 20px;
}

.pagination-wrapper {
  margin-top: 20px;
  text-align: right;
}

.dialog-footer {
  text-align: right;
}

/deep/ .el-table th {
  background-color: #f5f7fa !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/law_case/case_detail.vue